import React, { Component } from 'react';
import { ButtonToolbar, Button, FormGroup, Radio, ControlLabel, Grid, Row, Col, Tabs, Tab, Table, Panel } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from "react-select";
import { PropTypes } from 'prop-types';

import { Notes } from './tabs/Notes';
import { HandleMessage } from '../../../HandleMessage';
import { TitleRow } from '../../../TitleRow';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { SortIndicator } from '../../../SortIndicator';
import { ProviderSelectionsCommand } from '../../commands/ProviderSelectionsCommand';
import { LayoutCommand } from '../../commands/LayoutCommand';
import { LinesCommand } from '../../commands/LinesCommand';
import { PathStopsCommand } from '../../commands/PathStopsCommand';
import { SetOfDayTypesCommand } from '../../commands/SetOfDayTypesCommand';
import { SchedulesCommand } from '../../commands/SchedulesCommand';
import { DrawCommand } from '../../commands/DrawCommand';

export class GenerateSchedules extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        getOwnEdition: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            edition: undefined,
            commands: {
                providerSelections: new ProviderSelectionsCommand(),
                layouts: new LayoutCommand(),
                lines: new LinesCommand(),
                stops: new PathStopsCommand(),
                setOfDayTypes: new SetOfDayTypesCommand(),
                schedules: new SchedulesCommand(),
                draw: new DrawCommand(),
            },
            providerSelections: {
                data: {
                    line: "",
                    layout: "",
                    stopsSched: true,
                    lineSched: false,
                    scheduleGenerationSelections: []
                },
                search: true
            },
            data: {
                layouts: [],
                lines: [],
                stops: [],
                setOfDayTypes: [],
                schedules: [],
            },
            form: {
                layout: undefined,
                line: undefined,
                stops: [],
                schedules: {},
                date: undefined,
                type: 1,
            },
            validations: {
                schedulesComponents: [
                    "DayTimesheet",
                    "CompactDayTimesheet",
                    "VerticalDayTimesheet",
                    "HorizontalTabularDayTimesheet",
                    "VerticalTabularDayTimesheet",
                ]
            },
            render: {
                tab: 1,
                setOfDayTypes: [],
                schedulesComponents: [],
                notesComponents: [],
            },
            sort: {
                column: "code",
                order: "ascending",
            },
            actions: {
                isLoadingEdition: true,
                isLoadingLayouts: true,
                isLoadingLines: true,
                isLoadingSchedules: true,
                isLoadingSetOfDayTypes: true,
                isGenerating: false,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        }

    }

    componentDidMount() {
        this.context.selectApp('bussched', false);
        this.getProviderSelections();
        this.getSetOfDayTypes();
        this.getLayouts();

        const edition = this.context.getOwnEdition();
        edition.addObserver(this);
        edition.updateSync(new Date())

        this.setState({
            edition: edition
        });
    }

    componentWillUnmount() {
        this.state.edition.removeObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = false;

        this.setState({
            actions: actions
        });
    }

    updateNetwork() {
        this.setState({
            loadingLines: true
        }, () => {
            this.getLines(this.state.edition);
        });
    }

    updatePlanning() {
        this.setState({
            loadingSchedules: true
        }, () => {
            this.getSchedules(this.state.edition);
        });
    }

    // ----------------------

    getProviderSelections() {
        const { commands } = this.state;
        commands.providerSelections.get(
            (a) => this.getProviderSelectionsSuccessCallback(a)
        );
    }

    getLayouts() {
        const { actions, commands } = this.state;
        commands.layouts.list(
            (a) => this.listSuccessCallback(a, "layouts", "isLoadingLayouts"),
            (a) => this.listErrorCallback(a, "layouts", "isLoadingLayouts")
        );

        actions.isLoadingLayouts = true;

        this.setState({
            actions: actions
        });
    }

    getLines(edition) {
        const { actions, commands } = this.state;
        commands.lines.list(
            edition.network,
            (a) => this.listSuccessCallback(a, "lines", "isLoadingLines", () => this.updateLines()),
            (a) => this.listErrorCallback(a, "lines", "isLoadingLines")
        );

        actions.isLoadingLines = true;

        this.setState({
            actions: actions
        });
    }

    getStops(edition) {
        const { form, actions, commands } = this.state;

        commands.stops.listStops(
            edition.network,
            form.line.id,
            (a) => this.listSuccessCallback(a, "stops", "isLoadingStops"),
            (a) => this.listErrorCallback(a, "stops", "isLoadingStops")
        );

        actions.isLoadingStops = true;

        this.setState({
            actions: actions
        });
    }

    getSetOfDayTypes() {
        const { actions, commands } = this.state;
        commands.setOfDayTypes.listFull(
            (a) => this.listSuccessCallback(a, "setOfDayTypes", "isLoadingSetOfDayTypes"),
            (a) => this.listErrorCallback(a, "setOfDayTypes", "isLoadingSetOfDayTypes")
        );

        actions.isLoadingSetOfDayTypes = true;

        this.setState({
            actions: actions
        });
    }

    getSchedules(edition) {
        const { actions, commands } = this.state;
        commands.schedules.list(
            edition.planning,
            (a) => this.listSuccessCallback(a, "schedules", "isLoadingSchedules"),
            (a) => this.listErrorCallback(a, "schedules", "isLoadingSchedules")
        );

        actions.isLoadingSchedules = true;

        this.setState({
            actions: actions
        });
    }

    updateProviderSelections() {
        const { providerSelections, form, render, commands } = this.state;

        providerSelections.data.stopsSched = form.type === 1;
        providerSelections.data.referenceDate = form.date;
        providerSelections.data.line = form.line.code;
        providerSelections.data.layout = form.layout

        const found = providerSelections.data.scheduleGenerationSelections.findIndex(
            i => i.line === providerSelections.data.line && i.layout === providerSelections.data.layout.id && i.stopsSched === providerSelections.data.stopsSched
        )

        let generationSelections = {
            stops: [],
            stopsSched: providerSelections.data.stopsSched,
            line: form.line.code,
            layout: form.layout.id,
            componentSchedules: [],
            referenceDate: form.referenceDate,
            layoutNotes: []
        };


        if (providerSelections.data.stopsSched) {

            form.stops.map(s => generationSelections.stops.push({
                id: 0,
                code: s.code
            }))
        }
        generationSelections.stops.sort((a, b) => a.code - b.code)

        render.notesComponents.map(n => generationSelections.layoutNotes.push({
            id: 0,
            componentId: n.id,
            text: n.notes
        }))
        generationSelections.layoutNotes.sort((a, b) => a.componentId - b.componentId);

        for (let componentId in form.schedules) {
            generationSelections.componentSchedules.push({
                id: 0,
                componentId: parseInt(componentId.split('-')[1], 10),
                schedules: form.schedules[componentId]
            })
        }
        generationSelections.componentSchedules.sort((a, b) => a.componentId - b.componentId)
        for (let i = 0; i < generationSelections.componentSchedules.length; i++) {
            generationSelections.componentSchedules[i].schedules.sort((a, b) => a.scheduleId - b.scheduleId);
        }

        if (found === -1) {
            providerSelections.data.scheduleGenerationSelections.push(generationSelections);
        } else {
            generationSelections.id = providerSelections.data.scheduleGenerationSelections[found].id;
            this.updateSelectionLayoutNotes(providerSelections.data, generationSelections, found);
            this.updateSelectionSchedules(providerSelections.data, generationSelections, found);
            this.updateSelectionStops(providerSelections.data, generationSelections, found);
            providerSelections.data.scheduleGenerationSelections[found] = generationSelections;
        }

        commands.providerSelections.update(
            providerSelections.data,
            (a) => this.getProviderSelectionsSuccessCallback(a)
        );
    }

    // ----------------------

    listSuccessCallback(result, dataType, action, callback) {
        const { data, actions } = this.state;

        data[dataType] = result;

        // Update data
        this.setState({
            data: data,
            actions: actions
        }, () => {
            actions[action] = false;
            this.checkIfSelectionExists("stops" !== dataType);
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, action) {
        const { data, actions, message } = this.state;

        actions[action] = false;
        data[dataType] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            data: data,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    getProviderSelectionsSuccessCallback(result) {
        if (null === result || undefined === result) {
            return;
        }

        const { actions, providerSelections, form, render, data } = this.state;

        providerSelections.data = result;

        if (actions.isGenerating) {
            return;
        }

        form.date = result.referenceDate;
        form.layout = result.layout;
        form.type = result.stopsSched ? 1 : 2;
        render.tab = result.stopsSched ? 1 : 2;

        this.setState({
            providerSelections: providerSelections,
            form: form,
            render: render,
        }, () => {
            const { edition } = this.state;

            edition.update(new Date(form.date));
            this.onChangeLayoutSelected();
            this.updateLines();
        });
    }

    generationSuccessCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });
    }

    generationErrorCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ----------------------

    updateLines() {
        const { form, data, providerSelections } = this.state;

        form.line = data.lines.find(line => line.code === providerSelections.data.line);

        this.setState({
            form: form,
        }, () => {
            this.onChangeLineSelected();
        });
    }

    updateSelectionStops(providerSelections, newSelection, sgsPosition) {
        newSelection.stops.forEach(
            stop => {
                const found = providerSelections.scheduleGenerationSelections[sgsPosition].stops.find(i => i.code === stop.code)
                if (found !== undefined) {
                    stop.id = found.id;
                }
            }
        )
    }

    updateSelectionSchedules(providerSelections, newSelection, sgsPosition) {
        providerSelections.scheduleGenerationSelections[sgsPosition].componentSchedules.forEach(
            sched => {
                let index = newSelection.componentSchedules.findIndex(i => i.componentId === sched.componentId)
                if (index !== -1) {
                    newSelection.componentSchedules[index].id = sched.id;
                }
            }
        )

        const schedsToDelete = providerSelections.scheduleGenerationSelections[sgsPosition].componentSchedules.filter(component => newSelection.componentSchedules.findIndex(cs => cs.componentId === component.componentId) === -1);
        //This means that schedules must be deleted
        if (0 !== schedsToDelete.length) {
            providerSelections.scheduleGenerationSelections[sgsPosition].componentSchedules =
                providerSelections.scheduleGenerationSelections[sgsPosition].componentSchedules.filter(s => schedsToDelete.findIndex(sd => sd.componentId === s.componentId) === -1);
        }
    }

    updateSelectionLayoutNotes(providerSelections, newSelection, sgsPosition) {
        providerSelections.scheduleGenerationSelections[sgsPosition].layoutNotes.forEach(
            note => {
                let index = newSelection.layoutNotes.findIndex(i => i.componentId === note.componentId)
                if (index !== -1) {
                    newSelection.layoutNotes[index].id = note.id;
                }
            }
        )

        let notesToDelete = providerSelections.scheduleGenerationSelections[sgsPosition].layoutNotes.filter(note => newSelection.layoutNotes.findIndex(n => n.componentId === note.componentId) === -1);
        //This means that notes components must be deleted
        if (0 !== notesToDelete.length) {
            let updatedNotes = providerSelections.scheduleGenerationSelections[sgsPosition].layoutNotes.filter(n => notesToDelete.findIndex(nd => nd.componentId === n.componentId) === -1);
            providerSelections.scheduleGenerationSelections[sgsPosition].layoutNotes = updatedNotes;
        }
    }

    findSgsPosition(providerSelections, newSelection) {
        for (var i = 0; i < providerSelections.scheduleGenerationSelections.length; i++) {
            if (providerSelections.scheduleGenerationSelections[i].stops.length === newSelection[0].stops.length) {
                //Create and populate arrays for comparisons
                const stopCodes = [];
                const newlayoutComponentIds = [];
                const existinglayoutComponentIds = [];

                providerSelections.scheduleGenerationSelections[i].stops.forEach(s2 => stopCodes.push(s2.code));
                providerSelections.scheduleGenerationSelections[i].layoutNotes.forEach(ln => existinglayoutComponentIds.push(ln.componentId));
                newSelection[0].layoutNotes.forEach(ln => newlayoutComponentIds.push(ln.componentId));

                //If this is true it means it is an existing selection. 
                if (JSON.stringify(stopCodes) === JSON.stringify(newSelection[0].stops) && JSON.stringify(existinglayoutComponentIds) === JSON.stringify(newlayoutComponentIds)) {
                    return i;
                }
            }
        }

        return -1;
    }

    //returns found SGS or undefined it not found
    checkIfSgsExists() {
        const { providerSelections, form } = this.state;

        if (!providerSelections.search || form.line === undefined || form.layout === undefined) return;

        const sgs = providerSelections.data.scheduleGenerationSelections;

        return sgs.find(
            i => i.line === form.line.code && i.layout === form.layout.id && i.stopsSched === (form.type === 1)
        )
    }

    checkIfSelectionExists(fullUpdate = false) {
        const { providerSelections } = this.state;
        if (!providerSelections.search) {
            return;
        }

        const { form, data, render } = this.state;

        if (fullUpdate) {
            form.layout = data.layouts.find(layout => undefined !== providerSelections.data.layout && null !== providerSelections.data.layout && layout.id === providerSelections.data.layout.id);
            form.line = data.lines.find(line => line.code === providerSelections.data.line);
        }

        const selection = this.checkIfSgsExists();
        if (selection !== undefined) {
            if (selection.stopsSched) {
                if (data.stops !== undefined) {
                    if (form.type === 1) {
                        selection.stops.forEach(stop => {
                            const found = data.stops.find(e => e.code === stop.code);
                            if (found !== undefined) {
                                form.stops.push(found);
                            }
                        });
                    }
                }
            }

            const schedules = selection.componentSchedules;
            schedules.forEach((sched) => {
                let auxScheds = []
                const objKey = `${form.line.code}-${sched.componentId}-${form.type}`;
                sched.schedules.forEach(i => auxScheds.push(i));
                form.schedules[objKey] = auxScheds;
            });

            selection.layoutNotes.forEach((note) => {
                let found = render.notesComponents.find(i => i.id === note.componentId);
                if (found !== undefined) {
                    found.notes = note.text;
                }
            })
        } else {
            form.stops = [];
            form.schedules = {};
            render.notesComponents.forEach(
                note => note.notes = ''
            )
        }

        this.setState({
            form: form,
        }, () => {
            if (fullUpdate) {
                this.onChangeLineSelected();
                this.onChangeLayoutSelected();
            }
        });
    }

    getSetOfDayTypesSubsets(setOfDayTypes, setOfDayTypesId) {
        const selectedSetOfDayTypes = setOfDayTypes.find(dT => dT.id === setOfDayTypesId);
        const subsets = [];

        if (undefined !== selectedSetOfDayTypes) {
            setOfDayTypes.forEach(set => {
                if (setOfDayTypesId !== set.id) {
                    const dayTypes = set.dayTypes;
                    let output = false;

                    dayTypes.forEach(dayType => {
                        output |= undefined !== selectedSetOfDayTypes.dayTypes.find(setDayType => setDayType.id === dayType.id);
                    });

                    if (output) {
                        subsets.push(set.id);
                    }
                }
            });
        }

        return subsets;
    }

    getScheduleClassName(form, dayTypeComponentId, schedule) {
        if (undefined === form.line) {
            return "";
        }

        if (undefined === form.schedules[`${form.line.code}-${dayTypeComponentId}-${form.type}`]) {
            return "";
        }

        return undefined === form.schedules[`${form.line.code}-${dayTypeComponentId}-${form.type}`].find(s => s === schedule.id) ?
            "" :
            "checked";
    }


    // ----------------------

    onChangeSort(column) {
        const { sort } = this.state;

        if (sort.column === column) {
            sort.order = sort.order === "ascending" ? "descending" : "ascending";
        } else {
            sort.column = column;
            sort.order = "ascending";
        }

        this.setState({
            sort: sort
        });
    }

    sort(first, second) {
        const { sort } = this.state;

        var a = (first)[sort.column];
        var b = (second)[sort.column];

        if (a === undefined && b === undefined) {
            return 0;
        } else if (a === undefined) {
            if (sort.order === "ascending") {
                return 1;
            } else {
                return -1;
            }
        } else if (b === undefined) {
            if (sort.order === "ascending") {
                return -1;
            } else {
                return 1;
            }
        }

        if (sort.order === "ascending") {
            return typeof a === 'number' ? a - b : a.localeCompare(b);
        }
        return typeof b === 'number' ? b - a : b.localeCompare(a);
    }

    onSelectValue(e, property, callback = undefined) {
        const { form } = this.state;

        form[property] = null === e ? undefined : e;
        this.checkIfSelectionExists();

        this.setState({
            form: form
        }, () => {
            if (undefined !== callback && "function" === typeof callback) {
                callback();
            }
        });
    }

    onChangeReferenceDateChange(date) {
        const { form } = this.state;

        form.date = date;

        this.setState({
            referenceDate: date,
        }, () => {
            const { edition } = this.state;
            edition.update(new Date(date));
        });
    }

    onChangeLineSelected() {
        const { edition, form } = this.state;

        if (undefined !== form.line) {
            this.getStops(edition);
        }
        else {
            form.stops = [];

            this.setState({
                form: form
            });
        }
    }

    onChangeLayoutSelected() {
        const { data, form, validations, render } = this.state;

        render.setOfDayTypes = [];
        render.schedulesComponents = [];
        let layoutDayTimesheetComponents = [];
        let setOfDayTypesCustomObjects = [];

        if (undefined !== form.layout) {
            // Schedules
            layoutDayTimesheetComponents = form.layout.components
                .filter(comp => validations.schedulesComponents.includes(comp.type));

            layoutDayTimesheetComponents.forEach((comp) => {
                if (undefined !== comp.dataIdentifier) {
                    const dayTypeComponentId = comp.id;
                    const dataIdentifierId = parseInt(comp.dataIdentifier.split('|%|')[0], 10);

                    setOfDayTypesCustomObjects.push({ dayTypeComponentId: dayTypeComponentId, setOfDayTypesId: dataIdentifierId });

                    //Get SetOfDayType subsets
                    const subsets = this.getSetOfDayTypesSubsets(data.setOfDayTypes, dataIdentifierId);

                    //Create the schedules list with custom objects that store the dayTypeComponentId, the setOfDayTypesId 
                    //and the corresponding scheduleId list
                    render.schedulesComponents.push({ dayTypeComponentId: dayTypeComponentId, setOfDayTypesId: dataIdentifierId, subsets: subsets, schedules: [] });
                }
            });

            setOfDayTypesCustomObjects.forEach((set) => {
                const setOfDayTypesObj = data.setOfDayTypes.find(dT => dT.id === set.setOfDayTypesId);
                if (undefined !== setOfDayTypesObj) {
                    render.setOfDayTypes.push(setOfDayTypesObj);

                    //Add the scheduleList to the correct schedules object, keeping in mind the schedules that might belong to a subset
                    render.schedulesComponents
                        .filter(component => component.dayTypeComponentId === set.dayTypeComponentId && component.setOfDayTypesId === set.setOfDayTypesId)
                        .forEach(component => component.schedules = data.schedules.filter(sched =>
                            undefined !== sched.setOfDayTypes &&
                            (
                                sched.setOfDayTypes.id === set.setOfDayTypesId ||
                                -1 !== component.subsets.findIndex(sub => sub === sched.setOfDayTypes.id)
                            )
                        ));
                }
            });

            // Notes
            render.notesComponents = form.layout.components
                .filter(comp => comp.type === 'Notes')
                .map(comp => Object.assign({ notes: "" }, comp));
        }

        this.setState({
            render: render
        }, () => this.checkIfSelectionExists());
    }

    onChangeNotes(e, componentId) {
        const { providerSelections, render } = this.state;

        const component = render.notesComponents
            .find(c => c.id === componentId);

        if (undefined !== component) {
            component.notes = e.target.value;
        }

        providerSelections.search = false;
        this.setState({
            render: render,
            providerSelections: providerSelections
        });
    }

    onSelectLineScheduleType() {
        const { render } = this.state;

        if (1 === render.tab) {
            render.tab = 2;
        }

        this.setState({
            render: render
        });
    }

    onSelectAllStops() {
        const { data, form } = this.state;

        var full = form.stops.length === data.stops.length;

        form.stops = [];
        if (!full) {
            data.stops.forEach(stop => form.stops.push(stop));
        }

        this.setState({
            form: form
        });
    }

    onStopRowClick(stop) {
        const { form } = this.state;
        const index = form.stops.findIndex(s => s.code === stop.code);

        if (index === -1) {
            form.stops.push(stop);
        }
        else {
            form.stops = form.stops.slice(0, index).concat(form.stops.slice(index + 1, form.stops.length));
        }

        this.setState({
            form: form
        });
    }

    onSelectAllSchedules(component) {
        const { providerSelections, form } = this.state;
        const objKey = `${form.line.code}-${component.dayTypeComponentId}-${form.type}`;
        let remove = true;

        //If the component doesn't exist in the dictionary, create with the correct format
        if (!Array.isArray(form.schedules[objKey])) {
            form.schedules = Object.assign(form.schedules, { [objKey]: [] });
        }

        //Check if any schedules are missing from the selection. If so, add them and don't delete any schedules.
        component.schedules.forEach(function (sched) {
            if (-1 === form.schedules[objKey].findIndex(s => s === sched.id)) {
                remove = false;
                form.schedules[objKey].push(sched.id);
            }
        })

        //If remove === true this means that we have to remove the schedType schedules from selectedSchedules
        if (remove) {
            component.schedules.forEach(function (sched) {
                let index = form.schedules[objKey].findIndex(s => s === sched.id);
                if (-1 !== index) {
                    form.schedules[objKey].splice(index, 1);
                }
            })
        }

        providerSelections.search = false;
        this.setState({
            form: form,
            providerSelections: providerSelections,
        });
    }

    onScheduleRowClick(schedule, scheduleSetOfDayTypesId) {
        const { form } = this.state;
        const objKey = `${form.line.code}-${scheduleSetOfDayTypesId}-${form.type}`;

        //Find the component index in the current selectedSchedules Dictionary
        let compIndex = Object.keys(form.schedules).findIndex(comp => comp === objKey);

        //If the component doesn't exist in the dictionary, create with the correct format and add the selected schedule to the component schedules list
        if (compIndex === -1) {
            if (Array.isArray(form.schedules[objKey])) {
                form.schedules[objKey].push(schedule.id);
            } else {
                form.schedules = Object.assign(form.schedules, { [objKey]: [] });
                form.schedules[objKey].push(schedule.id);
            }
        }
        //If it already exists, we need to check if the select schedule is already associated. If it isn't, add it. Otherwise, remove it.
        else {
            let schedIndex = form.schedules[objKey].findIndex(s => s === schedule.id);

            if (schedIndex === -1) {
                form.schedules[objKey].push(schedule.id);
            } else {
                form.schedules[objKey] = form.schedules[objKey]
                    .slice(0, schedIndex)
                    .concat(form.schedules[objKey]
                        .slice(schedIndex + 1, form.schedules[objKey].length)
                    );
            }
        }

        this.setState({
            form: form,
        });
    }

    onGenerateClick() {
        const { form } = this.state;

        if (Object.keys(form.schedules).length !== 0 && form.layout !== undefined) {
            const { render, actions, commands, message } = this.state;

            const data = {
                lineId: form.line.id,
                Notes: render.notesComponents.map(component => Object.assign({}, { componentId: component.id, notes: component.notes })),
                lineCode: form.line.code,
                ComponentSchedules: {},
                referenceDate: form.date,
            };

            for (let objKey in form.schedules) {
                const newKey = objKey.split('-')[1];
                data.ComponentSchedules[newKey] = form.schedules[objKey];
            }

            actions.isGenerating = true;
            if (form.type === 1) {
                if (form.stops.length !== 0) {

                    data.Stops = form.stops;

                    this.updateProviderSelections();
                    commands.draw.generateBusSched(
                        form.layout,
                        data,
                        (a) => this.generationSuccessCallback(a),
                        (a) => this.generationErrorCallback(a)
                    );
                } else {
                    message.show = true;
                    message.message = "Antes de gerar é necessário selecionar pelo menos uma paragem.";
                    message.style = "warning";
                    message.title = "Aviso";
                    message.icon = "alert";
                }
            } else {
                this.updateProviderSelections();
                commands.draw.generateLineSched(
                    form.layout,
                    data,
                    (a) => this.generationSuccessCallback(a),
                    (a) => this.generationErrorCallback(a)
                );
            }

            this.setState({
                actions: actions,
                message: message
            });
        }
        else {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário selecionar pelo menos um horário e um layout.",
                    style: "warning",
                    icon: "alert"
                }
            });
        }
    }

    onTabSelected(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ----------------------

    renderEditionLoadingFeedback(isLoadingEdition) {
        return (
            <HandleMessage
                title="A Carregar a Edição..."
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isLoadingEdition}
                small
                noButtons />
        );
    }

    renderGeneratingFeedback(isGenerating) {
        return (
            <HandleMessage
                title="A Gerar..."
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isGenerating}
                small
                noButtons />
        );
    }

    renderForm() {
        const { data, form, actions } = this.state;

        if (actions.isLoadingLines) {
            return <LoadingSpinner />
        }

        return (
            <Grid className="margin-top-15" fluid>
                <FormGroup controlId="formLine">
                    <Row>
                        <Col sm={2} md={1}>
                            <ControlLabel className="padding-top-10">Linha</ControlLabel>
                        </Col>
                        <Col sm={10} md={11}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Linha selecionada"
                                noOptionsMessage={() => "Sem Linhas Configurados"}
                                onChange={(e) => this.onSelectValue(e, "line", (a) => { this.onChangeLineSelected(a); })}
                                options={data.lines.sort((a, b) => (a.code > b.code) ? 1 : -1)} // ascending
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    if (null !== form.line && undefined !== form.line) {
                                        return form.line.code === a.code;
                                    }
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => `${label.code} | ${label.goName}`}
                                value={form.line}
                            />
                        </Col>
                    </Row>
                    <Row className="padding-top-7">
                        <Col sm={2} md={1}>
                            <ControlLabel className="padding-top-10">Layout</ControlLabel>
                        </Col>
                        <Col sm={10} md={11}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Layout selecionado"
                                noOptionsMessage={() => "Sem Layouts Configurados"}
                                onChange={(e) => this.onSelectValue(e, "layout", () => this.onChangeLayoutSelected())}
                                options={data.layouts.sort((a, b) => a.name.localeCompare(b.name))}  // ascending
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    if (null !== form.layout && undefined !== form.layout) {
                                        return form.layout.id === a.id;
                                    }
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={form.layout}
                            />
                        </Col>
                    </Row>
                    <Row className="padding-top-7">
                        <Col sm={2} md={1}>
                            <ControlLabel className="padding-top-10">Data de Referência</ControlLabel>
                        </Col>
                        <Col sm={5} md={7}>
                            <DatePicker
                                id="referenceDateDatePicker"
                                dateFormat="DD/MM/YYYY"
                                value={form.date}
                                placeholder="Data de Referência"
                                onChange={(e) => this.onChangeReferenceDateChange(e)} />
                        </Col>
                        <Col sm={5} md={4}>
                            <Radio key={1}
                                className="padding-top-7"
                                checked={form.type === 1}
                                onChange={() => this.onSelectValue(1, "type")}
                                inline >
                                Horário de Paragem
                            </Radio>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Radio key={2}
                                className="padding-top-7 no-margin-left"
                                checked={form.type === 2}
                                onChange={() => this.onSelectValue(2, "type", () => { this.onSelectLineScheduleType() })}
                                inline >
                                Horário de Linha
                            </Radio>
                        </Col>
                    </Row>
                </FormGroup>
            </Grid>
        );
    }

    renderOrientationLabel(orientation) {
        let output = "";

        switch (orientation) {
            case 'C':
                output = "Circular";
                break;

            case 'R':
                output = "Volta";
                break;

            case 'G':
                output = "Ida";
                break;

            case undefined:
                output = "Não Definido";
                break;

            default:
                output = "Ambos";
                break;
        }

        return output;
    }

    renderStopsTab(scheduleType, stopsList, selectedStops) {
        const { sort } = this.state;

        if (2 === scheduleType) {
            return null;
        }

        return (
            <Tab eventKey={1} key="geral" title="Paragens">
                <Table responsive striped hover>
                    <thead>
                        <tr>
                            <th className="width-20p" onClick={() => this.onChangeSort('code')}>
                                Código {sort.column === "code" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                            </th>
                            <th className="width-60p" onClick={() => this.onChangeSort('name')}>
                                Nome {sort.column === "name" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                            </th>
                            <th className="width-20p">
                                Orientação
                            </th>
                            <th>
                                <Button bsSize="small" className="pull-right" onClick={() => this.onSelectAllStops()}>SELECIONAR TUDO</Button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            stopsList.sort((a, b) => this.sort(a, b)).map((stop, idx) =>
                                <tr key={`stop-${idx}`}
                                    className={`busched selectable ${selectedStops.findIndex(s => s.code === stop.code) !== -1 ? "checked" : ""}`}
                                    onClick={() => this.onStopRowClick(stop)}>
                                    <td>{stop.code !== 'undefined' ? stop.code : ''}</td>
                                    <td>{stop.name !== 'undefined' ? stop.name : ''}</td>
                                    <td colSpan={2}>{this.renderOrientationLabel(stop.orientation)}</td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
            </Tab>
        );
    }

    renderSetOfDayTypesLabel(setOfDayTypes) {
        if (undefined === setOfDayTypes) {
            return null;
        }

        return (
            <div className="margin-top-15 padding-top-7 control-label">
                {setOfDayTypes.name}
            </div>
        );
    }

    renderSchedulesTab() {
        const { render, form } = this.state;

        if (render.schedulesComponents.length === 0 || render.setOfDayTypes.length === 0 || form.layout === undefined) {
            return (
                <Panel key="semLayout" className="margin-top-15">
                    <Panel.Heading>
                        <Panel.Title> Atenção </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body> Tipos de dia não configurados no Layout.</Panel.Body>
                </Panel>
            );
        }

        const { edition } = this.state;

        return (
            <div>
                {
                    render.schedulesComponents.map((component, idx) => <Grid key={`day-type-schedules-${idx}`} fluid>
                        <Row>
                            <Col sm={2}>
                                {this.renderSetOfDayTypesLabel(render.setOfDayTypes[idx])}
                            </Col>
                            <Col sm={10} className="table-small-screens">
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th className="width-70p">Nome</th>
                                            <th className="width-30p">Edição</th>
                                            <th><Button bsSize="small" bsStyle="default" className="pull-right" onClick={() => this.onSelectAllSchedules(component)}>SELECIONAR TUDO</Button></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {component.schedules.map((schedule, index) => <tr key={`sched-${index}`}
                                            className={`busched selectable ${this.getScheduleClassName(form, component.dayTypeComponentId, schedule)}`}
                                            onClick={() => this.onScheduleRowClick(schedule, component.dayTypeComponentId)}>
                                            <td>{schedule.name}</td>
                                            <td colSpan={2}>{edition.getPlanningEditionName(schedule.planningEdition)}</td>
                                        </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Grid>
                    )
                }
            </div>
        );
    }

    renderBody() {
        const { form, actions } = this.state;

        if (actions.isLoadingStops) {
            return <LoadingSpinner />;
        }


        const { data, render } = this.state;

        return (
            <Tabs id="bussched_tabs" activeKey={render.tab} onSelect={(a) => this.onTabSelected(a)}>
                {this.renderStopsTab(form.type, data.stops, form.stops)}

                <Tab eventKey={2} key="sched" title="Horários">
                    {this.renderSchedulesTab()}
                </Tab>

                <Tab eventKey={3} key="notes" title="Observações" className="padding-15">
                    <Notes components={render.notesComponents}
                        onChange={(a, b) => this.onChangeNotes(a, b)} />
                </Tab>
            </Tabs>
        );
    }

    renderContent(isWaiting) {
        if (isWaiting) {
            return (
                <LoadingSpinner />
            );
        }

        return (
            <Grid fluid>
                {this.renderForm()}
                {this.renderBody()}
            </Grid>
        );
    }

    render() {
        const { actions, message } = this.state;

        return (
            <div>
                <TitleRow title="Gerar Horário" showSeparator={true}>
                    <Col className="padding-0">
                        <ButtonToolbar className="pull-right">
                            <Button onClick={() => this.onGenerateClick()}>GERAR</Button>
                        </ButtonToolbar>
                    </Col>
                </TitleRow>

                {this.renderContent(actions.isLoadingLayouts || actions.isLoadingLines || actions.isLoadingSchedules || actions.isLoadingSetOfDayTypes)}
                {this.renderGeneratingFeedback(actions.isGenerating)}
                {this.renderEditionLoadingFeedback(actions.isLoadingEdition)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/schedules/native/Generate.js